import { createStyles, makeStyles } from "@material-ui/core";
import { RelodeTheme } from "../";

export const useDesktopStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                display: "grid",
                gridTemplateColumns: "1fr",
                gridTemplateRows: "96px max-content",
                height: "100vh",
                backgroundColor: "#F5F5F9",
            },
            headerWrapper: {
                backgroundColor: theme.palette.common.white,
                boxShadow: "0 2px 14px 0 rgba(26,48,108,0.1)",
                padding: theme.spacing(1, 16, 1, 3),
                display: "grid",
                gridTemplateColumns: "auto max-content max-content max-content",
                alignItems: "center",
            },
            logo: {
                marginRight: theme.spacing(2),
            },
            header: {
                display: "flex",
                alignItems: "center",
            },
            headerText: {
                fontStyle: "italic",
                whiteSpace: "nowrap",
                overflow: "hidden",
                lineHeight: "normal",
                textOverflow: "ellipsis",
                maxWidth: "400px",
                paddingRight: theme.spacing(1),
                paddingLeft: theme.spacing(1),

                [theme.breakpoints.down("md")]: {
                    fontSize: "1.2rem",
                    maxWidth: 300,
                    display: "inline-block",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                },
            },
            contentWrapper: {
                display: "grid",
                gridGap: theme.spacing(2),
                gridTemplateColumns: "auto fit-content(35%)",
                height: "100%",
                //overflow: "auto",
                padding: theme.spacing(4, 8, 0, 8),
            },
            mainContent: {
                // border: "1px solid red",
                display: "flex",
                flexDirection: "column",
                paddingBottom: theme.spacing(8),
            },
            mainContentWrapper: {
                display: "flex",
                flexDirection: "column",
                flex: 1,
                backgroundColor: theme.palette.common.white,
            },
            sideBar: {
                // border: "1px solid blue",
                display: "grid",
                gridTemplateColumns: "1fr",
                gridTemplateRows: "min-content",
                gridAutoRows: "min-content",
                gridAutoFlow: "row",
                gridRowGap: theme.spacing(2),
            },
            sideBarPane: {
                padding: theme.spacing(1),
                backgroundColor: theme.palette.common.white,
            },
            pageSection: {
                flex: 1,
            },

            scrollWrapper: {
                flex: 1,
                position: "relative",
            },
            scroller: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                position: "absolute",
                overflowY: "auto",
            },
            tabs: {
                borderBottom: "2px solid #F5F5F9",
                backgroundColor: theme.palette.common.white,
            },
            busy: {
                height: 5,
                backgroundColor: theme.palette.secondary.dark,
            },
            notBusy: {
                height: 5,
                backgroundColor: "transparent",
            },
            titleContainer: {
                display: "flex",
                flexDirection: "column",
            },
            pageActionsOptions: {
                marginRight: theme.spacing(4),
                marginTop: 0,
            },
            backButton: {
                marginBottom: theme.spacing(2),
            },
            statusLabel: {
                marginLeft: theme.spacing(1.5),
            },
            mediumAndDownHide: {
                [theme.breakpoints.down("md")]: {
                    display: "none",
                },
            },
        }),
    { name: "DesktopPage" }
);
